export default __webpack_public_path__ + "static/media/25-TapestryOfTuscany.54e026c2.jpeg";